import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vue-auth";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "./registerServiceWorker";
import '@fortawesome/fontawesome-free/css/all.css';
import "font-awesome/css/font-awesome.css";
import Vuetify from 'vuetify';
import firebase from 'firebase/app';
import moment from 'moment'
import vuetify from '@/plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import VueObserveVisibility from 'vue-observe-visibility'
import VuetifyConfirm from 'vuetify-confirm'
Vue.use(VuetifyConfirm, { vuetify ,
  buttonTrueText: 'Sim',
  buttonFalseText: 'Não',
})

Vue.use(VueObserveVisibility)
Vue.use(VueTheMask)

Vue.use(Vuetify, {
 iconfont: 'fa'
})

Vue.config.productionTip = false;

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINSENDERID,
  appId : process.env.VUE_APP_FIREBASE_APPID
};

firebase.initializeApp(config);

Vue.filter('formatDateHour', function(value) {
  if (moment(value).isValid()) {
    return moment(value).format('DD/MM/YYYY HH:mm')
  }
  return "";
});

Vue.filter('formatDate', function(value) {
  if (moment(value).isValid()) {
    return moment(value).format('DD/MM/YYYY')
  }
  return "";
});

Vue.filter('formatHour', function(value) {
  if (moment(value).isValid()) {
    return moment(value).format('HH:mm')
  }
  return "";
});

Vue.filter('formatCpf', function (value) {
  if (!value) return ''
  value = value.toString().replace(/\D/g,'')
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
})

Vue.filter('formatCpfCnpj', function (value) {
  if (!value) return ''
  value = value.toString().replace(/\D/g,'')
  if (value.length === 11) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else {
    return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }
  
})

Vue.filter('formatPhone', function (value) {
  if (!value) return ''
  value = value.toString().replace(/\D/g,'')
  return value.replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 $2 $3-$4");
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
